import { useIsMobile } from '../../../utils/getIsMobile';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Button } from '../../input/Button';
import { Flex } from '../../layout/Flex';
import { Spin } from '../../layout/Spin/Spin';
import { Typography } from '../../typography/Typography';
import { openNalogSite } from '../PartnerApprovalPage/utils/openNalogSite';
import { DIALOG_STEPS } from './constants';
import { usePartnerSelfEmployedDialog } from './hooks/usePartnerSelfEmployedDialog';
import { PartnerSelfEmployedDialogProps } from './types';

export const PartnerSelfEmployedDialog = ({
    onRegistered,
    onClose,
}: PartnerSelfEmployedDialogProps) => {
    const t = useTranslation();
    const { isLoading, handleCheck } = usePartnerSelfEmployedDialog({
        onRegistered,
    });
    const isMobile = useIsMobile();

    const titleContent = (
        <Typography variant="title2" weight="bold">
            {t('Станьте самозанятым')}
        </Typography>
    );

    const mainContent = (
        <Flex direction="column" width="100%" spacing={2.5}>
            <Flex as="ol" p={0} m={0}>
                {DIALOG_STEPS.map((step, index) => (
                    <Typography as="li" key={index} variant="body" mb={1}>
                        {`${index + 1}. ${t(step)}`}
                    </Typography>
                ))}
            </Flex>
            <Flex width="100%" direction={isMobile ? 'column' : 'row-reverse'} spacing={1}>
                <Button
                    size="l"
                    width="100%"
                    variant="filled"
                    onClick={handleCheck}
                    style={{ letterSpacing: '0.7px' }}
                >
                    {isLoading ? <Spin color="var(--color-invert)" size={20} /> : t('Проверить')}
                </Button>
                <Button
                    size="l"
                    width="100%"
                    color="secondary"
                    variant="filled"
                    onClick={openNalogSite}
                    style={{ letterSpacing: '0.7px' }}
                >
                    {t('Перейти в «Мой налог»')}
                </Button>
            </Flex>
        </Flex>
    );

    return (
        <SmartDrawer
            onClose={onClose}
            hideTrigger={true}
            titleContent={titleContent}
            mainContent={mainContent}
        />
    );
};
